/** Mexican mobile numbers: accept local digits, +52 and the former +521 prefix. */
export function normalizeClubPhone(value: string): string {
  let digits = value.replace(/\D/g, '');
  if (digits.length === 12 && digits.startsWith('52')) digits = digits.slice(2);
  else if (digits.length === 13 && digits.startsWith('521')) digits = digits.slice(3);
  return digits;
}

export type ClubAccessMode = 'login' | 'register';

export function clubAccessMessage(status: string): string {
  if (status === 'not_found') return 'No encontramos ese registro. Verifica tu celular o elige Crear mi cuenta.';
  if (status === 'mismatch') return 'No pudimos confirmar tus datos. Escribe el nombre con el que te registraste y tu celular. Si necesitas ayuda, contacta a ALÉA.';
  return 'No pudimos iniciar sesión. Intenta de nuevo.';
}
